import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {EquipmentCardInterfaces, EquipmentEnums} from '@namespaces/equipment.namespace';
import {EquipmentDataFlowService, ModalTypes} from '../services/equipment-data-flow.service';
import {CalibrationLabelPipe} from '@pipes/calibration-label/calibration-label.pipe';
import {PreviewModalService} from '@services/preview-modal.service';
import {UploadedFile} from '@interfaces/file.interface';

@Component({
    selector: 'app-equipment-view-common',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'equipment-view-common.component.html',
    styles: [`
        [data-equipment-view-body] > g-col:first-child {
            align-self: stretch;
            display: flex;
            flex-direction: column;
        }

        img {
            display: block;
        }
    `]
})

export class EquipmentViewCommonComponent implements OnInit {

    @Input() equipment: EquipmentCardInterfaces.Card.ItemView;

    public types = EquipmentEnums.Type;

    constructor(
        public calibrationLabelPipe: CalibrationLabelPipe,
        private dataService: EquipmentDataFlowService,
        private filesPreviewService: PreviewModalService,
    ) {
    }

    ngOnInit() {

    }

    showPhotos() {
        if (!this.equipment.apparatus.images.length) {
            return;
        }

        this.filesPreviewService.show({
            files: this.equipment.apparatus.images,
            title: 'Просмотр фотографий оборудования'
        });
    }

    showCalibrationFile(files: UploadedFile[]) {
        if (!files || !files.length) {
            return;
        }
        const status = this.equipment.apparatus.verification_status;
        const number = this.equipment.calibration ? this.equipment.calibration.number : '';
        const message = `
            Свидетельство о ${this.calibrationLabelPipe.transform(status, 'поверке', 'калибровке', 'поверке/калибровке')}
            ${number ? '№ ' + number : ''}
        `;

        this.filesPreviewService.show({
            files: files,
            title: message
        });
    }

    showDocument(file: UploadedFile) {
        this.filesPreviewService.show({
            files: [file]
        });
    }

    onEditClick() {
        this.dataService.onEdit$.next();
    }

    onAddCalibration() {
        this.dataService.addCalibration$.next();
    }
}
